import { render, staticRenderFns } from "./PageTouristAgency.vue?vue&type=template&id=1c5d0748&"
import script from "./PageTouristAgency.vue?vue&type=script&lang=js&"
export * from "./PageTouristAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c5d0748')) {
      api.createRecord('1c5d0748', component.options)
    } else {
      api.reload('1c5d0748', component.options)
    }
    module.hot.accept("./PageTouristAgency.vue?vue&type=template&id=1c5d0748&", function () {
      api.rerender('1c5d0748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/touristAgency/PageTouristAgency.vue"
export default component.exports